import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './fixed-tooltip.module.css'

const propTypes = {
    className: PropTypes.string,
    hideArrow: PropTypes.bool
}

export default function FixedTooltip({ children, className, hideArrow }) {
    return (
        <div
            className={cx(className, styles['fixed-tooltip-box'], {
                [styles['fixed-tooltip-box-with-arrow']]: !hideArrow
            })}
        >
            {children}
        </div>
    )
}

FixedTooltip.propTypes = propTypes
